import React from "react";
import { Container, Button } from "react-bootstrap";
import {
  CheckCircleFill,
  ArrowRight,
  ShieldCheck,
  Phone,
  LockFill,
} from "react-bootstrap-icons";

import RamFinLogo from "../../assets/images/congratulations/ramfin.png";
import FinlabLogo from "../../assets/images/header/logofront.svg";
import "./RamFinCongratulations.css";

export default function RamFinCongratulations() {
  const isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  const buttonText = isApple
    ? "Available Soon on App Store"
    : "Download RamFin App";

  const buttonLink = isApple
    ? "#"
    : "https://play.google.com/store/apps/details?id=com.personalloanramfin";

  const openStore = () => {
    if (!isApple) {
      window.open(buttonLink, "_blank");
    }
  };

  return (
    <div className="ramfin-page">
      <div className="bg-circle bg-circle-1"></div>
      <div className="bg-circle bg-circle-2"></div>
      <div className="bg-circle bg-circle-3"></div>
      <div className="bg-circle bg-circle-4"></div>

      <Container className="h-100 d-flex justify-content-center align-items-center py-5">
        <div className="success-card">
          <div className="top-badge">
            <img src={FinlabLogo} alt="FinLab" />

            <span>×</span>

            <img src={RamFinLogo} alt="RamFin" />
          </div>

          <div className="success-wrapper">
            <div className="success-ring"></div>

            <div className="success-icon">
              <CheckCircleFill />
            </div>
          </div>

          <div className="content">
            <span className="status-pill">
              🎉 Application Submitted
            </span>

            <h1>Congratulations!</h1>

            <p className="description">
              Your application has been successfully submitted to
              <strong> RamFinCorp</strong>.
              <br />
              Download the app to continue your loan journey.
            </p>

            <Button
              className="download-btn"
              size="lg"
              onClick={openStore}
            >
              <span>{buttonText}</span>

              {!isApple && (
                <ArrowRight
                  size={22}
                  className="ms-2"
                />
              )}
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}